import { Action, ActionItemWrapper } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { appMetaSelectors } from '../store/modules/appMeta';
import { teamSelectors } from '../store/modules/team';
import { userSelectors } from '../store/modules/user';

type useMoveToWorkspaceActionProps = {
  onMoveToUser: () => void;
  onMoveToTeam: () => void;
};

const ItemWrapper = styled(Item)`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    left: 10px;
    background: url(${({ icon }) => icon}) no-repeat center / 100%, transparent;
  }
`;

const useMoveToWorkspaceAction = ({ onMoveToUser, onMoveToTeam }: useMoveToWorkspaceActionProps) => {
  const workspace = useSelector(appMetaSelectors.selectWorkspace);
  const profile = useSelector(userSelectors.selectUserProfile);
  const name = `Send to ${workspace === 'team' ? 'User' : 'Team'} Workspace`;

  const teamAvatar = useSelector(teamSelectors.selectTeamAvatar);
  const avatar = workspace === 'team' ? profile?.avatar : teamAvatar;

  const handler = useCallback(() => {
    if (!profile) return;
    workspace === 'user' ? onMoveToTeam() : onMoveToUser();
  }, []);

  const action: Action = {
    disabled: false,
    autoClose: true,
    renderComponent: () => (
      <ActionItemWrapper onClick={handler}>
        <ItemWrapper icon={avatar} hasIcon={true} name={name} />
      </ActionItemWrapper>
    )
  };

  return action;
};

export default useMoveToWorkspaceAction;
